import type { LegalInline } from "@bednbody/ui/lib/legal-markdown";
import { parseLegalMarkdown } from "@bednbody/ui/lib/legal-markdown";
import { cn } from "@bednbody/ui/lib/utils";

function Inline({ runs }: { runs: readonly LegalInline[] }) {
  return (
    <>
      {runs.map((run, i) =>
        run.strong ? (
          <strong className="text-foreground" key={i}>
            {run.text}
          </strong>
        ) : (
          <span key={i}>{run.text}</span>
        ),
      )}
    </>
  );
}

/**
 * The document as the client app will read it — the same parser (#316), so a
 * heading or list that does not survive here will not survive there either.
 */
export function LegalPreview({ body }: { body: string }) {
  const blocks = parseLegalMarkdown(body);
  if (blocks.length === 0) {
    return <p className="text-sm text-muted-foreground">Nothing to preview yet.</p>;
  }
  return (
    <div className="space-y-2">
      {blocks.map((block, i) => {
        if (block.type === "heading") {
          return block.level === 2 ? (
            <h2 className="pt-3 text-base font-semibold text-foreground" key={i}>
              <Inline runs={block.inline} />
            </h2>
          ) : (
            <h3 className="pt-2 text-sm font-semibold text-foreground" key={i}>
              <Inline runs={block.inline} />
            </h3>
          );
        }
        if (block.type === "list") {
          const List = block.ordered ? "ol" : "ul";
          return (
            <List
              className={cn(
                "ml-4 space-y-1 text-sm text-muted-foreground",
                block.ordered ? "list-decimal" : "list-disc",
              )}
              key={i}
            >
              {block.items.map((item, j) => (
                <li key={j}>
                  <Inline runs={item} />
                </li>
              ))}
            </List>
          );
        }
        return (
          <p className="text-sm text-muted-foreground" key={i}>
            <Inline runs={block.inline} />
          </p>
        );
      })}
    </div>
  );
}
